module.exports = __webpack_public_path__ + "static/media/SmartRoute_Vertical_App.cb7e9c81.png";